import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "asModal_title"
}
const _hoisted_2 = { class: "asModal_inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["asModal", _ctx.modalClasses])
        }, [
          _createElementVNode("div", {
            class: "asModal_overlay",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBackdropClose && _ctx.onBackdropClose(...args)))
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["asModal_content", `-${_ctx.typeModal}`])
          }, [
            (_ctx.btnClose)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "asModal_close",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("svg", {
                    width: "25",
                    height: "24",
                    viewBox: "0 0 25 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("g", { "clip-path": "url(#clip0_18923_5892)" }, [
                      _createElementVNode("path", {
                        d: "M12.5007 10.586L16.7437 6.34299C17.1342 5.95252 17.7673 5.95252 18.1577 6.34299C18.5482 6.73345 18.5482 7.36652 18.1577 7.75699L13.9147 12L18.1577 16.243C18.5482 16.6335 18.5482 17.2665 18.1577 17.657C17.7673 18.0475 17.1342 18.0475 16.7437 17.657L12.5007 13.414L8.25772 17.657C7.86725 18.0475 7.23418 18.0475 6.84372 17.657C6.45325 17.2665 6.45325 16.6335 6.84372 16.243L11.0867 12L6.84372 7.75699C6.45325 7.36652 6.45325 6.73345 6.84372 6.34299C7.23418 5.95252 7.86725 5.95252 8.25772 6.34299L12.5007 10.586Z",
                        fill: "#203454"
                      })
                    ]),
                    _createElementVNode("defs", null, [
                      _createElementVNode("clipPath", { id: "clip0_18923_5892" }, [
                        _createElementVNode("rect", {
                          width: "24",
                          height: "24",
                          fill: "white",
                          transform: "translate(0.5)"
                        })
                      ])
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default", { close: _ctx.close })
            ])
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}